export default {
  common: {
    companyName: '常州星虹达电工科技有限公司',
    nav: {
      home: '首页',
      about: '关于我们',
      partners: '合作伙伴',
      equipment: '工艺设备',
      product: '产品中心',
      specs: '产品参数',
      contact: '联系我们'
    },
    home: {
      coreAdvantages: '核心优势',
      strictProcess: '严苛工艺标准',
      excellentQuality: '铸就卓越品质'
    },
    about: {
      title: '关于星虹达',
      introTitle: '公司简介',
      spiritTitle: '企业精神',
      honorTitle: '资质认证',
      honorSubtitle: '全球认证，品质保证'
    },
    partners: {
      bannerTitle: '全球信赖，驱动产业升级',
      bannerDesc: '凭借稳定的交付记录，对产品零缺陷的品质追求，我们成为多家国内外知名制造商的长期供应商',
      applicationTitle: '应用领域',
      partnerTitle: '合作伙伴',
      partnerSubtitle: '与行业领先企业建立长期战略合作关系',
      commitTitle: '品质承诺',
      commitDesc1: '我们深知，在精密制造领域，每一个细节都关乎产品的最终性能。因此，我们建立了严格的质量管理体系，从原材料采购到成品出库，每一个环节都经过严格的检验和控制。',
      commitDesc2: '通过与全球领先企业的长期合作，我们不断优化产品性能，提升服务水平，确保为客户提供稳定可靠的产品和及时高效的技术支持。',
      zeroDefect: '零缺陷',
      qualityTarget: '品质目标',
      timeliness: '及时性',
      techSupport: '技术支持',
      customization: '定制化',
      solutions: '解决方案',
      fullCoverage: '全覆盖',
      serviceNetwork: '服务网络'
    },
    equipment: {
      bannerTitle: '精密智造，源自硬核装备',
      bannerSubtitle: '工欲善其事，必先利其器。',
      bannerDesc: '星虹达引进先进的微细线拉丝机、退火涂漆机及在线检测系统，以领先装备确保产品品质。',
      coreEquip: '核心设备',
      coreEquipSubtitle: '国际先进水平的生产与检测设备',
      techAdvantage: '技术优势',
      techAdvantageSubtitle: '通过自动化与数字化改造，确保产品的一致性与稳定性',
      smartIdea: '智能制造理念',
      smartDesc1: '我们致力于通过自动化数字化改造，确保产品在高速生产下的线径公差一致性与漆膜强度的稳定性。',
      smartDesc2: '从原材料进厂到成品出库，每一个环节都在智能化系统的监控下进行，实现了生产过程的全程可视化、数据化管理。'
    },
    product: {
      categoryTitle: '产品类别',
      specsTitle: '产品参数',
      specsDesc: ''
    },
    footer: {
      description1: '专注微细与特种漆包线领域的专业生产厂家',
      description2: '致力于为全球客户提供高性能高可靠性的漆包线产品',
      contactTitle: '联系方式',
      addressLabel: '地址：',
      addressValue: '江苏省常州市武进区洛阳镇天井路8号',
      hotlineLabel: '服务热线：',
      emailLabel: '电子邮箱：',
      copyright: '© 2026 常州星虹达电工科技有限公司 版权所有'
    },
    contact: {
      title: '在线询价',
      subtitle: '填写以下表单，我们将在24小时内回复您',
      form: {
        companyName: '公司名称',
        companyNamePlaceholder: '请输入公司名称',
        contactPerson: '联系人',
        contactPersonPlaceholder: '请输入联系人',
        phone: '联系电话',
        phonePlaceholder: '请输入联系电话',
        email: '电子邮箱',
        emailPlaceholder: '请输入电子邮箱',
        modelRequest: '型号要求',
        modelRequestPlaceholder: '请输入型号要求',
        specsRequest: '规格要求',
        specsPlaceholder: '如：线径 0.05mm, Grade 2',
        quantity: '预计数量',
        quantityPlaceholder: '如：1000kg/月',
        application: '应用领域',
        applicationPlaceholder: '如：汽车电机、消费电子等',
        detail: '详细需求说明',
        detailPlaceholder: '请详细描述您的需求，包括特殊性能要求、交付时间等',
        privacyTitle: '隐私声明',
        privacyText: '您提交的信息仅用于业务沟通，我们承诺严格保密，不会泄露给任何第三方。',
        submit: '提交询价',
        submitting: '提交中...',
        success: '感谢您的询价！我们的工作人员将尽快与您联系。',
        fail: '提交失败，请稍后重试',
        error: '提交过程中发生错误，请检查网络'
      },
      factoryTitle: '工厂位置'
    }
  }
}
